import React from "react";
import { Users } from "lucide-react";

export const CONSENT_LABEL = "Allow my player's highlights to be shared with their Next O teammates (optional — you can change this anytime in your profile settings)";

export const ShareConsentCheckbox = ({ checked, onChange, testid = "share-consent" }) => (
  <label data-testid={testid} className="mt-5 flex items-start gap-3 rounded-lg border p-3.5 cursor-pointer min-h-[44px] transition-colors duration-200"
    style={{ borderColor: checked ? "rgba(212,175,55,0.7)" : "rgba(255,255,255,0.12)", background: checked ? "rgba(212,175,55,0.08)" : "rgba(13,13,13,0.8)" }}>
    <input data-testid={`${testid}-checkbox`} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 w-5 h-5 shrink-0 accent-[#D4AF37]" />
    <span className="text-[13px] leading-snug text-white/75"><Users size={12} className="inline -mt-0.5 mr-1 text-[#D4AF37]" />{CONSENT_LABEL}</span>
  </label>
);
